import React from 'react'
import "./index.css"
const Loader = () => {
  return (
    <div className='loader__container'>
        <div></div>
    </div>
  )
}

export default Loader